export default "/assets/images/graph-virus-sm.abf9969c62782dab.png";